import React from 'react';
import { m } from 'framer-motion';
import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon } from 'lucide-react';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const stats = [{
  icon: UsersIcon,
  value: '+8K',
  label: 'Entrenadores activos'
}, {
  icon: Building2Icon,
  value: '900+',
  label: 'Clubes y Colegios'
}, {
  icon: DownloadIcon,
  value: '+180.000',
  label: 'Sesiones descargadas'
}, {
  icon: ClockIcon,
  value: '+4 horas',
  label: 'Ahorradas / semana'
}];
const trustBadges = [{
  icon: GraduationCapIcon,
  title: 'Base Técnica',
  text: 'Diseñado por Javier Solana (14 años de exp, +600 jugadores formados).'
}, {
  icon: LayersIcon,
  title: 'Todas las Edades',
  text: 'Desde Premini (6-9 años) hasta niveles competitivos (U18/Junior).'
}, {
  icon: SmartphoneIcon,
  title: 'Multidispositivo',
  text: 'Tablet, móvil, PC o para imprimir — úsalo donde te quede cómodo.'
}];
export function TrustStats() {
  return <section className="border-y border-white/5 bg-bg-secondary py-8 sm:py-10" data-id="element-325" data-mp="192hx4pk2k6n3">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-326" data-mp="1du9m4vnku4b4">
        <ScrollHintTable minWidth="640px" data-id="element-327" data-mp="1dvt6oyg9n1ip">
          <div className="grid grid-cols-4 divide-x divide-white/10" data-id="element-328" data-mp="z5vf08j4ntor">
            {stats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-329" data-mp="144yihojglrum" data-mpi={i}>
                <stat.icon size={22} className="text-orange" data-id="element-330" data-mp="1muek6f6vrqcm" />
                <span className="font-heading text-xl font-bold text-white sm:text-2xl" data-id="element-331" data-mp="1msv4oqt1tjbw">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-332" data-mp="7g0m61w29lvc">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-semibold uppercase tracking-wider text-success" data-id="element-333" data-mp="2e14zvzd4xbo3">
          ✓ El Estándar Profesional en el Pabellón
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-334" data-mp="24bv86km7dv0i">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-bg-primary p-5" data-id="element-335" data-mp="1zdts88k2qbt9" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-orange/10" data-id="element-336" data-mp="1lfc78iljzdf1">
                <badge.icon size={20} className="text-orange" data-id="element-337" data-mp="3frjtl7jt6lz7" />
              </div>
              <div data-id="element-338" data-mp="3fp62taw5vvxg">
                <p className="font-heading text-sm font-semibold text-white" data-id="element-339" data-mp="3asp3rlnfbx5l">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-340" data-mp="3j9fyau0yknix">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}